// extracted by mini-css-extract-plugin
export default {"component":"game_component__0CyxE","enter":"game_enter__bEmvR","enterActive":"game_enterActive__b9yjE","exit":"game_exit__6LRIC","exitActive":"game_exitActive__K4RVe"};